import React from "react";

const Btn = ({
  variant,
  size,
  block,
  as,
  children,
  className = "",
  type,
  ...rest
}) => {
  const Component = as || "button";
  const classes = [
    "btn",
    variant ? `btn--${variant}` : "",
    size ? `btn--${size}` : "",
    block ? "btn--block" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");
  const buttonTypeProp =
    Component === "button" ? { type: type || "button" } : type ? { type } : {};
  return (
    <Component className={classes} {...buttonTypeProp} {...rest}>
      {children}
    </Component>
  );
};

export default Btn;
